import { AuthenticatedApiError, postAuthenticatedApi } from './postAuthenticatedApi';

export interface LoginPartnerDriverResult {
  promotionCode: string;
  promotionType: string;
  promotionRef: string;
  campaignRef: string;
}

export interface InitiatePartnerDriverEnrollmentResult {
  promotionCode: string;
  campaign?: {
    promotionType?: string;
    groupName?: string;
    planId?: string;
    promotion?: {
      promotionRef?: string;
    } | null;
  } | null;
}

export interface PartnerDriverPromoDetails {
  promotionCode: string;
  promotionType?: string;
  promotionRef?: string;
  campaignRef?: string;
  planId?: string;
}

export class PartnerClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PartnerClientError';
  }
}

export function mapInitiatePartnerDriverEnrollment(
  result: InitiatePartnerDriverEnrollmentResult,
): PartnerDriverPromoDetails {
  return {
    promotionCode: result.promotionCode,
    promotionType: result.campaign?.promotionType,
    promotionRef: result.campaign?.promotion?.promotionRef,
    campaignRef: result.campaign?.groupName,
    planId: result.campaign?.planId,
  };
}

async function postPartnerApi<T>(path: string, body: unknown): Promise<T> {
  try {
    return await postAuthenticatedApi<T>(path, body);
  } catch (error) {
    if (error instanceof AuthenticatedApiError) {
      throw new PartnerClientError(error.message);
    }
    throw error;
  }
}

export async function loginPartnerDriverRequest(input: {
  promotionRef: string;
  authorizationCode: string;
  platformName: string;
}): Promise<LoginPartnerDriverResult> {
  const data = await postPartnerApi<{ loginPartnerDriver: LoginPartnerDriverResult }>(
    '/api/partner/login-driver',
    input,
  );
  return data.loginPartnerDriver;
}

export async function initiatePartnerDriverEnrollmentRequest(input: {
  promotionRef: string;
  authorizationCode: string;
  originPartnerPlatform: string;
}): Promise<InitiatePartnerDriverEnrollmentResult> {
  const data = await postPartnerApi<{
    initiatePartnerDriverEnrollment: InitiatePartnerDriverEnrollmentResult;
  }>('/api/enrollment/initiate-partner-driver', input);
  return data.initiatePartnerDriverEnrollment;
}
